<template>
  <el-main>
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>个人事务管理</el-breadcrumb-item>
        <el-breadcrumb-item>报销管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="" style="margin-left: -100px;">
          <el-col :span="5">
            <el-select v-model="form.atype" placeholder="请选择类别" style="margin-right: 0; width: 100%;">
              <el-option label="申请人" value="realname" checked></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" style="margin-right: 10px;">
            <el-input placeholder="请输入内容" v-model="form.key" @keyup.enter.native="search" clearable @clear="search">
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-col>
        </el-form-item>
        <el-form-item label="更多" prop="type">
          <el-col :span="3" style="margin-right: 20px;">
            <el-select v-model="form.year" placeholder="选择年份" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option :label="v" :value="v" v-for="(v, i) in yearList" :key="i"></el-option>
            </el-select>
          </el-col>

          <el-col :span="3">
            <el-select v-model="form.month" placeholder="选择月份" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option :label="`${v}月`" :value="v" v-for="(v, i) in dd.month" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="已选条件">
          <el-tag v-for="tag in tags" :key="tag.key" effect="dark" closable @close="removeTag(tag)">
            {{ tag.key }}: {{ tag.value }}
          </el-tag>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row
        :row-class-name="tableRowClassName">
        <el-table-column prop="department" label="部门" header-align="center" align="center" min-width="120" />
        <el-table-column prop="application_time" label="报销员工" header-align="center" align="center" min-width="200">
          <template slot-scope="scope">
            {{ scope.row.staff?.realname }} {{ scope.row.staff?.en_name }}
          </template>
        </el-table-column>
        <!-- 本月 -->
        <el-table-column label="本月" header-align="center" align="center">
          <template #header>
            {{ form.year ? (form.month ? `${form.year}年${form.month}月` : `${form.year}年`) : (form.month ? `${year}年${form.month}月` : `${year}年${month}月`) }}
          </template>
          <el-table-column prop="status" label="报销状态" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.month && Object.keys(scope.row.month).length > 0" class="circle-tag"
                :style="{ 'background': dd.expense_status_c[scope.row.month?.status].color }">
                <div class="word">{{ dd.expense_status_c[scope.row.month?.status].word }}</div>
              </div>
              <div v-else>暂无</div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="主管审核状态" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.month && Object.keys(scope.row.month).length > 0" class="circle-tag"
                :style="{ 'background': dd.leader_check_status_c[scope.row.month?.leader_check_status].color }">
                <div class="word">{{ dd.leader_check_status_c[scope.row.month?.leader_check_status].word }}
                </div>
              </div>
              <div v-else>暂无</div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="财务审核状态" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.month && Object.keys(scope.row.month).length > 0" class="circle-tag"
                :style="{ 'background': dd.finance_check_status_c[scope.row.month?.finance_check_status].color }">
                <div class="word">{{ dd.finance_check_status_c[scope.row.month?.finance_check_status].word }}
                </div>
              </div>
              <div v-else>暂无</div>
            </template>
          </el-table-column>
          <el-table-column prop="pay_status" label="支付状态" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.month && Object.keys(scope.row.month).length > 0" class="circle-tag"
                :style="{ 'background': dd.pay_status_c[scope.row.month?.pay_status].color }">
                <div class="word">{{ dd.pay_status_c[scope.row.month?.pay_status].word }}</div>
              </div>
              <div v-else>暂无</div>
            </template>
          </el-table-column>
          <el-table-column prop="expense_amount" label="报销总额" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.month && Object.keys(scope.row.month).length > 0">
                <div>{{ scope.row.expense_amount }}</div>
              </div>
              <div v-else>暂无</div>
            </template>
          </el-table-column>
          <el-table-column prop="expense_amount" label="业务报销总额" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.month && Object.keys(scope.row.month).length > 0">
                <div>{{ scope.row.business_amount }}</div>
              </div>
              <div v-else>暂无</div>
            </template>
          </el-table-column>
          <el-table-column prop="expense_amount" label="日常报销总额" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.month && Object.keys(scope.row.month).length > 0">
                <div>{{ scope.row.daily_amount }}</div>
              </div>
              <div v-else>暂无</div>
            </template>
          </el-table-column>
          <el-table-column prop="pay_amount" label="已支付金额" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.month && Object.keys(scope.row.month).length > 0">
                <div>{{ scope.row.pay_amount }}</div>
              </div>
              <div v-else>暂无</div>
            </template>
          </el-table-column>
          <el-table-column prop="unpay_amount" label="未支付金额" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.month && Object.keys(scope.row.month).length > 0">
                <div>{{ scope.row.unpay_amount }}</div>
              </div>
              <div v-else>暂无</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="three_total_expense_amount" label="近三个月报销总额" header-align="center" align="center" min-width="180" />
        <el-table-column prop="three_business_total_amount" label="近三个月业务报销总额" header-align="center" align="center"
          min-width="180" />
        <el-table-column prop="three_daily_total_amount" label="近三个月日常报销总额" header-align="center" align="center" min-width="180" />
        <el-table-column prop="three_total_pay_amount" label="近三个月已支付金额" header-align="center" align="center" min-width="180" />
        <el-table-column prop="three_total_unpay_amount" label="近三个月未支付金额" header-align="center" align="center" min-width="180" />
        <el-table-column prop="" label="操作" header-align="center" width="100" align="center" fixed="right"
          v-if="NodeInclude('185') || NodeInclude('186')">
          <template slot-scope="scope">
            <div class="linkwrap">
              <el-link type='primary' class="link" @click="handleView(scope.row)" v-if="NodeInclude('186')">查看</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="expense" v-if="NodeInclude('187')">
        <div>{{ form.year ? (form.month ? `${form.year}年${form.month}月` : `${form.year}年`) : (form.month ? `${year}年${form.month}月` : `${year}年${month}月`) }}</div>
        <div>报销总额合计：{{ total_expense_amount }}</div>
        <div>业务报销金额合计：{{ total_business_amount }}</div>
        <div>日常报销金额合计：{{ total_daily_amount }}</div>
        <div>报销已支付合计：{{ total_pay_amount }}</div>
        <div>报销未支付合计：{{ total_unpay_amount }}</div>
      </div>
      <div class="apage">
        <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
import { thousands } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'expense',
  data() {
    return {
      nodeLimtList: [],
      level: '',
      userId: '',
      year: '',
      month: '',
      yearList: [],
      itemList: [
        {
          gifts: [],
        }
      ],
      total_expense_amount: '0.00',
      total_business_amount: '0.00',
      total_daily_amount: '0.00',
      total_pay_amount: '0.00',
      total_unpay_amount: '0.00',
      total: 0,
      perPage: 30,
      p: 1,
      form: {
        key: '',
        atype: 'realname',
      },
      monthList: [],
      monthForm: {
        year: new Date().getFullYear(),
        month: '',
        realname: '',
      },
      userList: [],
    }
  },
  computed: {
    tags() {
      let temp = [
        {
          key: this.dd.expenseType[this.form.atype],
          val: 'atype',
          value: this.form.key,
          active: !!this.form.atype && !!this.form.key,
        },
        {
          key: '年份',
          val: 'year',
          value: `${this.form.year}年`,
          active: !!this.form.year,
        },
        {
          key: '月份',
          val: 'month',
          value: `${this.form.month}月`,
          active: !!this.form.month,
        },
      ]
      temp = temp.filter((item) => item.active)
      return temp
    },
  },
  created() {
    var date = new Date()
    this.year = date.getMonth() == '0' ? date.getFullYear() - 1 : date.getFullYear()
    this.month = date.getMonth() == '0' ? '12' : date.getMonth()
    var year = date.getFullYear() + 1
    this.getYearList(year);
  },
  mounted() {
    this.getStoreFn()
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;
      // 移除'#'字符  
      const url = hash.substring(1);

      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },

    dateValue(dateArr) {
      if (Array.isArray(dateArr)) {
        return this.fdate(dateArr[0]) + '-' + this.fdate(dateArr[1])
      } else {
        return ''
      }
    },

    link(url) {
      this.$router.push(url)
    },

    getYearList(y) {
      for (let i = 2022; i < y; i++) {
        this.yearList.push(i)
      }
    },

    expenseSearch() {
      this.search()
    },

    handleView(item) {
      this.$router.push({
        path: '/expense/person',
        query: { id: item.staff?.id },
      })
    },

    search() {
      this.p = 1
      store.commit('setExpenseData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },

    getStoreFn() {
      this.form = Object.keys(store.state.expenseData).length != 0 ? store.state.expenseData : this.form
      this.getList()
    },

    getList() {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const postData = {
        ...this.form,
        p: this.p,
        per_page: this.perPage,
        [this.form.atype]: this.form.key,//搜索
      }
      api.getExpenseList(postData).then((res) => {
        this.itemList = res.itemList
        if (this.itemList?.length > 0) {
          this.itemList = this.itemList.map((item) => {
            item.expense_amount = thousands(Number(item.expense_amount))
            item.business_amount = thousands(Number(item.business_amount))
            item.daily_amount = thousands(Number(item.daily_amount))
            item.pay_amount = thousands(Number(item.pay_amount))
            item.unpay_amount = thousands(Number(item.unpay_amount))
            item.three_total_expense_amount = thousands(Number(item.three_total_expense_amount))
            item.three_business_total_amount = thousands(Number(item.three_business_total_amount))
            item.three_daily_total_amount = thousands(Number(item.three_daily_total_amount))
            item.three_total_pay_amount = thousands(Number(item.three_total_pay_amount))
            item.three_total_unpay_amount = thousands(Number(item.three_total_unpay_amount))
            return item
          })
        }
        this.total = +res.totalNum
        setTimeout(() => {
          //权限
          this.level = store.state.level
          this.userId = store.state.userId
          this.total_business_amount = thousands(Number(res.total_business_amount))
          this.total_daily_amount = thousands(Number(res.total_daily_amount))
          this.total_expense_amount = thousands(Number(res.total_expense_amount))
          this.total_pay_amount = thousands(Number(res.total_pay_amount))
          this.total_unpay_amount = thousands(Number(res.total_unpay_amount))
        }, 200);
      })
    },
    removeTag(tag) {
      !{
        type: () => {
          this.form['key'] = undefined
        },
      }[tag.val]?.()
      this.form[tag.val] = ''
      this.form.key = this.form.atype == '' ? '' : this.form.key
      store.commit('setExpenseData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },
    handleCurrentChange(p) {
      this.p = p
      store.commit('setExpenseData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },
    tableRowClassName({ row }) {
      if (row.staff) {
        if (row.staff.status == "2") {
          return "warning-row";
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.filterwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 20px 0;

  .filter {
    width: 85%;
  }

  .btnarea {
    box-sizing: border-box;
    width: 15%;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.el-checkbox-group.filtergroup .el-checkbox {
  width: auto;
}

.apage {
  background: var(--bg); /* 0819修改 */
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.table {
  @extend %box;
  padding: 30px;
}

.expense {
  @extend %start;
  padding: 30px 0;

  >div {
    margin-right: 30px;
  }
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}

.description {
  @extend %start;

  div {
    &:nth-of-type(1) {
      width: 90px;
    }

    &:nth-of-type(2) {
      width: calc(100% - 150px);
    }

    &:nth-of-type(3) {
      width: 60px;
    }
  }
}
</style>
<style lang="scss">
.el-table tr {
  &.warning-row {
    // background: #d1d1d1;

    .el-table__cell {
      color: #aaa;
    }
  }
}
</style>